<template>
<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 14.627C11.5637 14.627 14.25 11.9407 14.25 8.62695C14.25 5.31324 11.5637 2.62695 8.25 2.62695C4.93629 2.62695 2.25 5.31324 2.25 8.62695C2.25 11.9407 4.93629 14.627 8.25 14.627Z" stroke="#56D0E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.7498 16.1277L12.4873 12.8652" stroke="#56D0E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
